module.exports = __webpack_public_path__ + "img/3.b6652b67.png";